import { useState, useEffect, useRef, useMemo, useCallback  } from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2, Grid, Box, CardMedia, IconButton, FormControl } from '@mui/material'
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import MyTextInput from '../../../components/inputs/MyTextInput';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import MyAutoCompleteJavier from '../../../components/inputs/MyAutoCompleteJavier';
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import MyDateTimePicker from '../../../components/inputs/MyDateTimePicker';
import DieselTankSlider from '../../Diesel/fuelUp/components/DieselTankSlider.jsx';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import axios from 'axios';
import moment from 'moment-timezone';

import DeleteIcon from "@mui/icons-material/Delete";
import { ConstructionOutlined } from '@mui/icons-material';

function CrearEditarGasoMax({ open, onClose, refresh, carga, isEditing }) {

    const normalizarFotos = (fotos) => {
        if (!fotos) return [];

        let fotosArray = fotos;

        if (typeof fotos === 'string') {
            try {
            fotosArray = JSON.parse(fotos);
            } catch {
             fotosArray = fotos
                .split('},{')
                .map((f, i, arr) => {
                if (i > 0) f = '{' + f;
                if (i < arr.length - 1) f = f + '}';
                return JSON.parse(f);
                });
            }
        }

        if (!Array.isArray(fotosArray)) {
            fotosArray = [fotosArray];
        }

        return fotosArray
            .filter(f => f?.ruta)
            .map(f => ({
            id: f.id,
            ruta: f.ruta,
            nombre: f.nombre,
            file: null,
            preview: `https://apifuncionesgenerales.ebtapps.com/img/${f.ruta.replace(/\\/g, '/')}`,
            _status: 'existing',
            }));
    };

    const normalizarPdf = (pdf) => 
    {
        if (!pdf) return null;

        if (typeof pdf === 'object' && (pdf.nombre || pdf.ruta)) {
            return {
            id: pdf.id || null,
            nombre: pdf.nombre || (typeof pdf.ruta === 'string' ? pdf.ruta.split('/').pop() : 'Archivo.pdf'),
            ruta: pdf.ruta || null,
            file: null,
            _status: 'existing',
            };
        }

        if (typeof pdf === 'string') {
            return {
            id: null,
            nombre: pdf.split('/').pop(),
            ruta: pdf,
            file: null,
            _status: 'existing',
            };
        }

        return null;
    };

    const eliminarFoto = (foto, values, setFieldValue) => 
    {
        if (foto._status === 'new') {
            setFieldValue(
            'fotos',
            values.fotos.filter(f => f !== foto)
            );
            return;
        }

        const updated = values.fotos.map(f =>
            f === foto ? { ...f, _status: 'deleted' } : f
        );

        setFieldValue('fotos', updated);
    };

    //Función para formatear la fecha
    const formatDate = (date) => {
        if (!date) return ""; 

        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        //const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`; // Construir el formato
    
        return formattedDateTime;
    };

    const validationSchema = Yup.object({
        fecha: Yup.string().required('La fecha es obligatoria'),
        noEconomico: Yup.string().required('La unidad es obligatoria'),
        grupo: Yup.string().required('El grupo es obligatorio'),
        cliente: Yup.string().required('El cliente es obligatorio'),
        consumoLitros: Yup.number()
            .typeError('Debe ser un número válido')
            .required('El consumo en litros es obligatorio')
            .moreThan(0, 'Debe ser mayor que 0'),
    });

    const initialValues = 
    {
        fecha: carga?.fecha ? moment(formatDate(carga.fecha), 'MM/DD/YY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,
        noEconomico: carga?.noEconomico || '',
        cliente: carga?.cliente || '',
        grupo: carga?.grupo || '',
        consumoPesos: carga?.consumoPesos || '',
        consumoLitros: carga?.consumoLitros || '',
        producto: 'Diesel',
        usuario: Cookies.get('ebt_nombre'),
        fotos: carga?.fotos ? normalizarFotos(carga.fotos) : [],
        pdf: carga?.pdf ? normalizarPdf(carga.pdf) : null,
        orden: carga?.orden || '',
        ubicacion: carga?.ubicacion || '',
        destino: carga?.destino || '',
        nivelDiesel: carga?.nivelDiesel || '',
        comentario: '',
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        
        const payload = {  
            fecha: values.fecha,
            noEconomico: values.noEconomico,
            cliente: values.cliente,
            grupo: values.grupo,
            consumoPesos: values.consumoPesos,
            consumoLitros: values.consumoLitros,
            producto: values.producto,
            usuario: values.usuario,
            orden: values.orden,
            ubicacion: values.ubicacion,
            destino: values.destino,
            nivelDiesel: values.nivelDiesel,
            comentario: values.comentario
        };

        const formData = new FormData();

        Object.entries(values).forEach(([k, v]) => {
            if (k !== 'fotos' && k !== 'pdf') formData.append(k, v);
        });

        const fotosNuevas = values.fotos.filter(f => f._status === 'new');

        const fotosEliminar = values.fotos
        .filter(f => f._status === 'deleted' && f.id)
        .map(f => f.id);

        fotosNuevas.forEach(f => {
            formData.append('fotos', f.file);
        });

        formData.append('fotosEliminar', JSON.stringify(fotosEliminar));

        if (values.pdf?._status === 'new') 
        {
            formData.append('file', values.pdf.file);
        }

        if (values.pdf?._status === 'deleted') 
        {
            formData.append('pdfEliminar', '1');
        }

        try 
        {
            if (isEditing) 
            {
                let responseEditar = await myApi.put(`/cargasFuel/editarGasoMax/${carga.id}`, formData);

                if(responseEditar.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga editada',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseEditar.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseEditar.data.data || 'Ya existe una carga con esa fecha y unidad',
                            target: document.getElementById('dialog1')
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al editar carga',
                            text: responseEditar.data.data || 'Ocurrió un error desconocido',
                            target: document.getElementById('dialog1')
                        });
                    }

                    console.error('Error de API:', responseEditar.data);
                }
            } 
            else 
            {
                let responseCrear = await myApi.post('/cargasFuel/crearGasoMax', formData);

                if(responseCrear.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Carga creada',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseCrear.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseCrear.data.data || 'Ya existe una carga con esa fecha y unidad',
                            target: document.getElementById('dialog1')
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al crear carga',
                            text: responseCrear.data.data || 'Ocurrió un error desconocido',
                            target: document.getElementById('dialog1')
                        });
                    }

                    console.error('Error de API:', responseCrear.data);
                }
            }
        } 
        catch (error) 
        {
            Swal.fire({
                icon: 'error',
                title: 'Error del servidor',
                text: error.response?.data?.message || error.message || 'Ocurrió un error desconocido',
            });
            console.error('Error saving charge:', error);
        }
    };

    const [tractoresEBT, setTractoresEBT] = useState([]);
    const [tractoresTEDEL, setTractoresTEDEL] = useState([]);
    const [cajasEBT, setCajasEBT] = useState([]);
    const [cajasTEDEL, setCajasTEDEL] = useState([]);

    const fetchAllUnidades = useCallback(async () => 
    {
        const statuses = ['A', 'I', 'S'];
        const companies = ['EBT', 'TEDEL'];

        try {
            const tractorRequests = companies.flatMap(company =>
                statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trucks/',
                        { company, status, tractor: null }
                    )
                )
            );

            const cajaRequests = companies.flatMap(company =>
                statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trailers/',
                        { company, status, trailer: null }
                    )
                )
            );

            const [tractorResponses, cajaResponses] = await Promise.all([
                Promise.all(tractorRequests),
                Promise.all(cajaRequests)
            ]);

            const tractoresRaw = tractorResponses.flatMap(r => r.data);
            const cajasRaw = cajaResponses.flatMap(r => r.data);

            const tractoresEBT = new Map();
            const tractoresTEDEL = new Map();
            const cajasEBT = new Map();
            const cajasTEDEL = new Map();

            tractoresRaw.forEach(t => {
                if (!t.tractor) return;

                const item = { value: t.tractor, label: t.tractor };

                if (t.company === 'EBT') {
                    tractoresEBT.set(t.tractor, item);
                } else if (t.company === 'TEDEL') {
                    tractoresTEDEL.set(t.tractor, item);
                }
            });

            cajasRaw.forEach(c => {
                if (!c.trailer) return;

                const item = { value: c.trailer, label: c.trailer };

                if (c.company === 'EBT') {
                    cajasEBT.set(c.trailer, item);
                } else if (c.company === 'TEDEL') {
                    cajasTEDEL.set(c.trailer, item);
                }
            });

            setTractoresEBT([...tractoresEBT.values()]);
            setTractoresTEDEL([...tractoresTEDEL.values()]);
            setCajasEBT([...cajasEBT.values()]);
            setCajasTEDEL([...cajasTEDEL.values()]);

        } catch (error) {
            console.error('Error cargando unidades', error);
        }
    }, []);

    useEffect(() => {
        fetchAllUnidades();
    }, [fetchAllUnidades]);

    return (
        <Dialog id="dialog1" open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{
    isEditing
      ? 'Editar Carga GasoMax'
      : 'Crear Carga GasoMax'
}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={{
                        ...initialValues
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    context={{ isEditing }}
                >
                    {({ isSubmitting, handleSubmit, errors, touched, values, setFieldValue }) => {

                        const catalog =
                            values.grupo === 'TRACTORES' && values.cliente?.includes('EBT')
                                ? tractoresEBT
                                : values.grupo === 'TRACTORES' && values.cliente?.includes('TEDEL')
                                ? tractoresTEDEL
                                : values.grupo === 'CAJAS' && values.cliente?.includes('EBT')
                                ? cajasEBT
                                : values.grupo === 'CAJAS' && values.cliente?.includes('TEDEL')
                                ? cajasTEDEL
                                : [];

                    return (
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyDateTimePicker
                                        name="fecha"
                                        label="FECHA"
                                        error={touched.fecha && Boolean(errors.fecha)}
                                        helperText={touched.fecha && errors.fecha}
                                    />
                                    {errors.fecha && touched.fecha ? (
                                        <div style={{ color: '#D3302F', fontSize: '12px' }}>{errors.fecha}</div>
                                    ) : null}
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="grupo"
                                        label="GRUPO"
                                        options={[
                                            { value: 'TRACTORES', label: 'TRACTORES' },
                                            { value: 'CAJAS', label: 'CAJAS' },
                                        ]}
                                        onChange={() => setFieldValue('noEconomico', null)}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="cliente"
                                        label="CLIENTE"
                                        options={[
                                            { value: 'EBT FREIGHT SA DE CV', label: 'EBT FREIGHT SA DE CV' },
                                            { value: 'TEDEL TRUCKING SA DE CV', label: 'TEDEL TRUCKING SA DE CV' },
                                        ]}
                                        onChange={() => setFieldValue('noEconomico', null)}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoCompleteJavier
                                        name="noEconomico"
                                        label="UNIDAD"
                                        options={catalog} 
                                        key={`noeconomico-${values.grupo}-${values.noEconomico}`} 
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyNumberInput
                                        name="consumoPesos"
                                        label="CONSUMO EN PESOS"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyNumberInput
                                        name="consumoLitros"
                                        label="CONSUMO EN LITROS"
                                    />
                                </Grid2>
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="orden"
                                        label="ORDEN"
                                    />
                                </Grid2>
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="ubicacion"
                                        label="UBICACIÓN"
                                    />
                                </Grid2>
                                <Grid2 size={{xs: 12, sm: 4}}>
                                    <MyTextInput
                                        name="destino"
                                        label="DESTINO"
                                    />
                                </Grid2>
                                <Grid2 size={{xs: 12, sm: 12}}>
                                    <FormControl fullWidth>
                                        <Field name="nivelDiesel">
                                            {({ field }) => (
                                            <DieselTankSlider
                                                label="Nivel de Diésel"
                                                value={values.nivelDiesel}
                                                onChange={(newValue) => {
                                                const valueToLabelMap = {
                                                    0: "EMPTY",
                                                    1: "1/16",
                                                    2: "1/8",
                                                    3: "3/16",
                                                    4: "1/4",
                                                    5: "5/16",
                                                    6: "3/8",
                                                    7: "7/16",
                                                    8: "1/2",
                                                    9: "9/16",
                                                    10: "5/8",
                                                    11: "11/16",
                                                    12: "3/4",
                                                    13: "13/16",
                                                    14: "7/8",
                                                    15: "15/16",
                                                    16: "FULL",
                                                };
                                                let nuevoValor = valueToLabelMap[newValue];
                                                setFieldValue('nivelDiesel', nuevoValor);
                                                }}
                                            />
                                            )}
                                        </Field>
                                    </FormControl>
                                </Grid2>
                                {isEditing && (
                                    <Grid2 size={{ xs: 12, sm: 4 }}>
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            style={{ display: "none" }}
                                            id="upload-pdf-form"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setFieldValue('pdf', {
                                                        id: null,
                                                        nombre: file.name,
                                                        file,
                                                        _status: 'new',
                                                    });
                                                }
                                                e.target.value = null; // reset input
                                            }}
                                        />
                                        <label htmlFor="upload-pdf-form">
                                            <Button
                                                variant="outlined"
                                                component="span"
                                                fullWidth
                                                color="secondary"
                                            >
                                                {values.pdf && values.pdf._status !== 'deleted' ? 'Reemplazar PDF' : 'Agregar PDF'}
                                            </Button>
                                        </label>
                                    </Grid2>
                                )}
                                {values.pdf && values.pdf._status !== 'deleted' && (
                                    <Grid2 size={{ xs: 12, sm: 12 }}>
                                        <Box position="relative" p={1} border="1px solid #ccc" borderRadius={2} display="flex" alignItems="center" justifyContent="space-between">
                                        <span>{values.pdf.nombre}</span>
                                        <IconButton
                                            onClick={() => setFieldValue('pdf', { ...values.pdf, _status: 'deleted' })}
                                            sx={{ backgroundColor: "rgba(255,255,255,0.7)" }}
                                        >
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                        </Box>
                                    </Grid2>
                                )}
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        capture="environment"
                                        multiple
                                        style={{ display: "none" }}
                                        id="upload-photo-form"
                                        onChange={(e) => {
                                        const files = Array.from(e.target.files);

                                        if (files.length > 0) 
                                        {
                                            const newFotos = files.map(file => ({
                                                id: null,
                                                ruta: null,
                                                nombre: file.name,
                                                file,
                                                preview: URL.createObjectURL(file),
                                                _status: 'new',
                                            }));

                                            setFieldValue('fotos', [...values.fotos, ...newFotos]);
                                        }

                                        // 🔑 CLAVE para iOS
                                        e.target.value = null;
                                        }}
                                    />
                                    <label htmlFor="upload-photo-form">
                                        <Button
                                        variant="outlined"
                                        component="span"
                                        fullWidth
                                        color="primary"
                                        >
                                        Agregar foto
                                        </Button>
                                    </label> 
                                </Grid2>
                                {values.fotos.length > 0 && (
                                    <Grid2 size={{ xs: 12, sm: 12 }}>
                                        <Grid2 container spacing={2}>
                                            {values.fotos.filter(f => f._status !== 'deleted').map((foto, idx) => (
                                                <Grid2 item xs={6} sm={4} key={idx}>
                                                    <Box position="relative">
                                                        <CardMedia
                                                        component="img"
                                                        height="140"
                                                        image={foto.preview}
                                                        sx={{ borderRadius: 2 }}
                                                        />

                                                        {/* Indicador de foto existente o nueva */}
                                                        <Box sx={{ position: 'absolute', bottom: 8, left: 8, backgroundColor: 'rgba(0,0,0,0.5)', color: '#fff', px: 1, borderRadius: 1, fontSize: 10 }}>
                                                            {foto.id ? 'Existente' : 'Nueva'}
                                                        </Box>

                                                        <IconButton
                                                        onClick={() => eliminarFoto(foto, values, setFieldValue)}
                                                        sx={{
                                                            position: "absolute",
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor: "rgba(255,255,255,0.7)",
                                                        }}
                                                        >
                                                        <DeleteIcon color="error" />
                                                        </IconButton>
                                                    </Box>
                                                </Grid2>
                                            ))}
                                        </Grid2>
                                    </Grid2>
                                )}

                                <DialogActions style={{ justifyContent: 'flex-end' }}>
                                    <Button type="submit" disabled={isSubmitting} variant="contained" color="primary">
                                        Guardar
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarGasoMax